// extracted by mini-css-extract-plugin
export default {"container":"SignDocumentsDialog_container__-zSme","buttonGroup":"SignDocumentsDialog_buttonGroup__VUB6m"};